import { BaseModel } from '../BaseModel';
import Auth from '../Auth';

export class CatalogBaseModel extends BaseModel {
  static get globalApiConfig() {
    const headers = {};
    const authToken = Auth.getAppToken();
    if (authToken) {
      headers.Authorization = `Bearer ${authToken}`;
    }
    return {
      baseURL: process.env.VUE_APP_CATALOG_API_URL,
      headers
    };
  }
}

export default CatalogBaseModel;
